import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './testimonial17.css'
import { useTranslation } from 'react-i18next';

const Testimonial17 = ({
  heading1 = undefined,
  content1 = undefined,

  author1Name = undefined,
  author1Position = undefined,
  author1Alt = 'María Sánchez',
  author1Src = './images/testimonials/mariasanchez.jpg',
  review1 = undefined,

  author2Name = undefined,
  author2Position = undefined,
  author2Alt = 'Carlos López',
  author2Src = './images/testimonials/carloslopez.jpg',
  review2 = undefined,

  author3Name = undefined,
  author3Position = undefined,
  author3Alt = 'Luisa Martínez',
  author3Src = './images/testimonials/luisamartinez.jpg',
  review3 = undefined,

  author4Name = undefined,
  author4Position = undefined,
  author4Alt = 'Juan Rodríguez',
  author4Src = './images/testimonials/juanrodriguez.jpg',
  review4 = undefined,
}) => {
  const { t } = useTranslation();

  return (
    <div className="thq-section-padding">
      <div className="testimonial17-max-width thq-section-max-width">
        <div className="testimonial17-container10">
          <h2 className="thq-heading-2">
            {heading1 ?? (
              <Fragment>
                <span className="testimonial17-text35">
                  {t('home.testimonial.heading')}
                </span>
              </Fragment>
            )}
          </h2>
          <span className="testimonial17-text11 thq-body-small">
            {content1 ?? (
              <Fragment>
                <span className="testimonial17-text32">{t('home.testimonial.content')}
                  {t('home.testimonial.content')}
                </span>
              </Fragment>
            )}
          </span>
        </div>
        <div className="thq-grid-2">
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card1"
              >
                <div className="testimonial17-container12">
                  <img
                    alt={author1Alt}
                    src={author1Src}
                    className="testimonial17-image1"
                  />
                  <div className="testimonial17-container13">
                    <strong className="thq-body-large">
                      {author1Name ?? (
                        <Fragment>
                          <span className="testimonial17-text26">
                            {t('home.testimonial.client1.name')}
                          </span>
                        </Fragment>
                      )}
                    </strong>
                    <span className="thq-body-small">
                      {author1Position ?? (
                        <Fragment>
                          <span className="testimonial17-text25">
                            {t('home.testimonial.client1.occupation')}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text14 thq-body-small">
                  {review1 ?? (
                    <Fragment>
                      <span className="testimonial17-text34">
                        {t('home.testimonial.client1.review')}
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card2"
              >
                <div className="testimonial17-container14">
                  <img
                    alt={author2Alt}
                    src={author2Src}
                    className="testimonial17-image2"
                  />
                  <div className="testimonial17-container15">
                    <strong className="thq-body-large">
                      {author2Name ?? (
                        <Fragment>
                          <span className="testimonial17-text29">
                            {t('home.testimonial.client2.name')}
                          </span>
                        </Fragment>
                      )}
                    </strong>
                    <span className="thq-body-small">
                      {author2Position ?? (
                        <Fragment>
                          <span className="testimonial17-text24">
                            {t('home.testimonial.client2.occupation')}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text17 thq-body-small">
                  {review2 ?? (
                    <Fragment>
                      <span className="testimonial17-text28">
                        {t('home.testimonial.client2.review')}
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card3"
              >
                <div className="testimonial17-container16">
                  <img
                    alt={author3Alt}
                    src={author3Src}
                    className="testimonial17-image3"
                  />
                  <div className="testimonial17-container17">
                    <strong className="thq-body-large">
                      {author3Name ?? (
                        <Fragment>
                          <span className="testimonial17-text27">
                            {t('home.testimonial.client3.name')}
                          </span>
                        </Fragment>
                      )}
                    </strong>
                    <span className="thq-body-small">
                      {author3Position ?? (
                        <Fragment>
                          <span className="testimonial17-text33">
                            {t('home.testimonial.client3.occupation')}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text20 thq-body-small">
                  {review3 ?? (
                    <Fragment>
                      <span className="testimonial17-text36">
                        {t('home.testimonial.client3.review')}
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card4"
              >
                <div className="testimonial17-container18">
                  <img
                    alt={author4Alt}
                    src={author4Src}
                    className="testimonial17-image4"
                  />
                  <div className="testimonial17-container19">
                    <strong className="thq-body-large">
                      {author4Name ?? (
                        <Fragment>
                          <span className="testimonial17-text31">
                            {t('home.testimonial.client4.name')}
                          </span>
                        </Fragment>
                      )}
                    </strong>
                    <span className="thq-body-small">
                      {author4Position ?? (
                        <Fragment>
                          <span className="testimonial17-text30">
                            {t('home.testimonial.client4.occupation')}
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text23 thq-body-small">
                  {review4 ?? (
                    <Fragment>
                      <span className="testimonial17-text37">
                        {t('home.testimonial.client4.review')}
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Testimonial17.propTypes = {
  heading1: PropTypes.element,
  content1: PropTypes.element,

  author1Name: PropTypes.element,
  author1Position: PropTypes.element,
  author1Alt: PropTypes.string,
  author1Src: PropTypes.string,
  review1: PropTypes.element,

  author2Name: PropTypes.element,
  author2Position: PropTypes.element,
  author2Alt: PropTypes.string,
  author2Src: PropTypes.string,
  review2: PropTypes.element,

  author3Name: PropTypes.element,
  author3Position: PropTypes.element,
  author3Alt: PropTypes.string,
  author3Src: PropTypes.string,
  review3: PropTypes.element,

  author4Name: PropTypes.element,
  author4Position: PropTypes.element,
  author4Alt: PropTypes.string,
  author4Src: PropTypes.string,
  review4: PropTypes.element,
}

export default Testimonial17
